import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import {
  addNotes,
  getmemberProgrammingNotes,
  getNotes,
  getNotesProgramCalandar,
} from "src/DAL/notesApi/Notes";
import GeneralCkeditor from "../GeneralCkeditor";
import { Button, Tooltip } from "@mui/material";
import {
  addmmeberNoteApi,
  inMemberProgramApiFroCalendar,
} from "../../DAL/notesApi/Notes";
import MUIAutocomplete from "../GeneralComponents/MUIAutocomplete";

const NotePad = ({ data, setChangeDis, changeDis }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [inputs, setInputs] = useState({
    description: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectProgram, setSelectProgram] = useState(null);
  const [changeFirst, setChangeFirst] = useState(false);

  const getNotesList = async () => {
    const getId = (item) => item?._id?._id || item?._id;
    const progrm_id = getId(selectProgram) || getId(data);

    const result = data?.type_member
      ? await getNotesProgramCalandar(data?.member_id, progrm_id)
      : data?.member_id
      ? await getmemberProgrammingNotes(data?.member_id)
      : await getNotes(progrm_id);

    if (result.code === 200) {
      setInputs((oldInputs) => ({
        ...oldInputs,
        description: result?.notes?.content || "",
      }));
      setChangeFirst(true);
      setChangeDis(false);
    } else {
      enqueueSnackbar(result.message, {
        variant: "error",
      });
    }
  };

  const handleAddNote = async () => {
    const getId = (item) => item?._id?._id || item?._id;
    const progrm_id = getId(selectProgram) || getId(data);
    const postData = {
      content: inputs.description,
    };

    if (data?.type_member) {
      postData.programId = progrm_id;
      postData.userId = data?.member_id;
    } else if (data?.member_id) {
      postData.userId = data?.member_id;
    } else {
      postData.programId = progrm_id;
    }

    setIsLoading(true);
    const result = data?.type_member
      ? await inMemberProgramApiFroCalendar(postData)
      : data?.member_id
      ? await addmmeberNoteApi(postData)
      : await await addNotes(postData);

    if (result.code === 200) {
      setChangeDis(false);
      enqueueSnackbar(result.message, { variant: "success" });
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleCustomChange = (value) => {
    if (changeFirst) {
      setChangeDis(true);
    }
  };

  useEffect(() => {
    getNotesList();
  }, [selectProgram?._id, data]);

  useEffect(() => {
    if (data?.program_list?.length > 0) {
      setSelectProgram(data.program_list[0]);
    }
  }, [data]);

  return (
    <div className="d-flex flex-column h-100 p-2">
      {data?.message && <p className="my-2 text-muted">{data?.message}</p>}
      {data?.program_list && data?.program_list.length > 0 ? (
        <div style={{ width: "100%" }} className="my-2">
          <Tooltip
            title={changeDis ? "Please save your changes first" : ""}
            placement="top"
            arrow
          >
            <div style={{ width: "100%", display: "inline-block" }}>
              <div
                style={{
                  pointerEvents: changeDis ? "none" : "auto",
                  opacity: changeDis ? 0.6 : 1,
                }}
              >
                <MUIAutocomplete
                  inputLabel="Programme"
                  required={true}
                  selectedOption={selectProgram}
                  setSelectedOption={(e) => {
                    setChangeFirst(false);
                    setSelectProgram(e);
                  }}
                  size="small"
                  optionsList={data?.program_list}
                  autoComplete="new-password"
                  name="title"
                  hideClearIcon={true}
                />
              </div>
            </div>
          </Tooltip>
        </div>
      ) : (
        ""
      )}
      <GeneralCkeditor
        setInputs={setInputs}
        onChangeCustom={handleCustomChange}
        inputs={inputs}
        name="description"
        editorHeight={400}
      />
      <Button
        variant="contained"
        className="mt-auto align-self-end mb-2"
        onClick={handleAddNote}
      >
        {isLoading ? "Loading..." : "Save Changes"}
      </Button>
    </div>
  );
};

export default NotePad;
